<template>
  <LoginForm
    :show-right-panel="true"
    :show-logo-link="true"
    :enable-redirect="true"
    :load-saved-credentials="true"
    :show-query-error="true"
    @login-success="handleLoginSuccess"
    @login-error="handleLoginError"
    @goto-signup="handleGotoSignup"
    @google-login="handleGoogleLogin"
  />
</template>

<script setup>
import LoginForm from "../components/LoginForm.vue";

// Event handlers for LoginForm
function handleLoginSuccess() {
  // Login success is handled by LoginForm's internal redirect logic
}

function handleLoginError(error) {
  // Error handling is managed by LoginForm
  console.log("Login error:", error);
}

function handleGotoSignup() {
  // Signup navigation is handled by LoginForm's internal redirect logic
  console.log("Navigating to signup");
}

function handleGoogleLogin() {
  // Google login is handled by LoginForm's internal logic
  console.log("Google login initiated");
}
</script>

<style>
input[type="checkbox"].custom-checkbox {
  width: 1.5em;
  height: 1.5em;
  accent-color: #d62467;
  margin-right: 8px;
  border: 2px solid #d62467;
  border-radius: 4px;
}
</style>
